import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { useQuery } from "@apollo/react-hooks";
import { usePreferences } from "@temp/@next/hooks";
import { Locale } from "@temp/@next/types";
import { prismicApolloClient } from "../prismic-config";

var _usePrismicQuery = function _usePrismicQuery(query, options) {
  return useQuery(query, _objectSpread({}, options, {
    client: prismicApolloClient
  }));
};

export var usePrismicQuery = function usePrismicQuery(query, options) {
  var _usePreferences = usePreferences(),
      preferences = _usePreferences.preferences;

  var locale = preferences.locale === Locale.EN ? "EN-US" : preferences.locale;
  return _usePrismicQuery(query, _objectSpread({}, options, {
    // TODO: https://medium.com/@jacky_ttt/day121-warning-heuristic-fragment-matching-going-on-8208b584cb5e
    fetchPolicy: "cache-and-network",
    variables: _objectSpread({}, options === null || options === void 0 ? void 0 : options.variables, {
      lang: locale.toLowerCase()
    })
  }));
};